import MetricList from "../../components/metrics/MetricList"

export const MetricsPage = () => {

    return (
        <MetricList></MetricList>
    )
}